export default "__VITE_ASSET__DTBfpF1U__"